module.exports = "<template> <div id=sio-menu-main></div> </template> ";